import { render } from "./Coach.vue?vue&type=template&id=66a90a1c"
import script from "./Coach.vue?vue&type=script&lang=js"
export * from "./Coach.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__